import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicRule, RuleEntity } from '@pdqdev/pdq-shared/dist/entities/Rules';
import { OrderProtectionFormGroup } from '../../model';

@Component({
  selector: 'order-protection-display-conditions',
  templateUrl: './order-protection-display-conditions.component.html',
  styleUrls: ['./order-protection-display-conditions.component.scss'],
  standalone: false,
})
export class OrderProtectionDisplayConditionsComponent implements OnInit {
  @Input() formGroup: FormGroup<OrderProtectionFormGroup>;
  @Input() displayRules: DynamicRule[];

  displayRulesEntities: RuleEntity[];

  ngOnInit(): void {
    this.displayRulesEntities = (this.displayRules ?? []).map((rule) => rule.entity);
  }
}
